import { Spread } from 'editor/src/store/design/types';

function getSpreadWidthFromSpread(spread: Spread) {
  return spread.pages.reduce((max, page) => Math.max(page.x + page.width, max), 0);
}

export default getSpreadWidthFromSpread;
